export const enum Routes {
    Both = "both",
    BothGoogle = "both_google",
    Flow = "main-flow",
    Loader = "loader",
    PromoPaywall = "paywall",
    Friends = "friends",
    NewYear = "newyear",
    ChallengesRedirect = "challenges-redirect",
    Pilates = "pilates",
    PilatesTiktok = "pilates-tt",
    Age = "age",
    Calisthenics = "calisthenics",
}
